import styled from 'styled-components';
import { Widget } from '@typeform/embed-react';

export const TypeFormWidget = styled(Widget)`
    height: 100vh;
`;
